<script setup lang="ts">
interface Props {
  modelValue: any;
  label?: string;
  placeholder?: string;
  error?: string;
  isRequired?: boolean;
}

withDefaults(defineProps<Props>(), {
  label: "",
  placeholder: "",
  isRequired: false,
});

interface Emits {
  (event: "update:modelValue", value: any): void;
}

defineEmits<Emits>();
</script>

<script lang="ts">
export default {
  name: 'StyledTextarea'
}
</script>

<template>
  <label class="flex flex-col gap-1">
    <span v-if="label" class="font-medium text-base"
      >{{ label }} <span class="text-red-500" v-if="isRequired">*</span>
    </span>

    <textarea
      :value="modelValue"
      :placeholder="placeholder"
      class="py-[0.625rem] px-[1rem] shadow-sm text-gray-900 rounded-md w-full border-2 text-sm bg-white"
      @input="
        (e) => $emit('update:modelValue', (e.target as HTMLInputElement).value)
      "
    >
    </textarea>

    <span v-if="error" class="!text-sm text-red-500">{{ error }}</span>
  </label>
</template>

<style scoped></style>
